import React, { useState, useEffect } from "react";
import cancel from "../../../assets/cancel.png";
import Loader from "../../Loader/Loader";
import { toast } from "react-hot-toast";
import api from "../../../utils/api";
import "./NewAdmission_Form.css";

const NewAdmission_Form = ({ data, setDisp, isEdit, setEdit, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [details, setDetails] = useState({
    gr: "",
    name: "",
    father_name: "",
    phone: "",
    application: ""
  });

  useEffect(() => {
    if (isEdit && data) {
      setDetails({
        gr: data.gr || "",
        name: data.name || "",
        father_name: data.father_name || "",
        phone: data.phone || "",
        application: data.application || ""
      });
    }
  }, [isEdit, data]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDetails(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      if (isEdit) {
        await api.put(`/newadmission/${data.id}`, details);
        toast.success("Admission updated successfully");
      } else {
        await api.post("/newadmission", details);
        toast.success("New admission added successfully");
      }
      
      if (onSuccess) onSuccess();
      setDisp();
      if (setEdit) setEdit(false);
    } catch (error) {
      toast.error(error.response?.data?.error || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setDisp();
    if (setEdit) setEdit(false);
  };

  return (
    <div className="advertisment__form_div_open">
      <div className="advertisment__form">
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '100%'
        }}>
          <h2 style={{margin: '0', fontSize: '24px'}}>{isEdit ? "Edit" : "Add"} New Admission</h2>
          <button
            type="button"
            className="close-button"
            onClick={handleClose}
            aria-label="Close form"
          >
            <img src={cancel} alt="cancel" />
          </button>
        </div>

        <form onSubmit={handleSubmit} style={{ width: '100%' }}>
          <div className="advertisment__form_input">
            <label className="input-label">
              <h5>GR Number:</h5>
              <input
                type="text"
                name="gr"
                value={details.gr}
                onChange={handleChange}
                placeholder="Enter GR Number"
                className="advertisment__form_input_small"
                required
              />
            </label>
          </div>

          <div className="advertisment__form_input">
            <label className="input-label">
              <h5>Student Name:</h5>
              <input
                type="text"
                name="name"
                value={details.name}
                onChange={handleChange}
                placeholder="Enter Student Name"
                className="advertisment__form_input_small"
                required
              />
            </label>
          </div>

          <div className="advertisment__form_input">
            <label className="input-label">
              <h5>Father's Name:</h5>
              <input
                type="text"
                name="father_name"
                value={details.father_name}
                onChange={handleChange}
                placeholder="Enter Father's Name"
                className="advertisment__form_input_small"
                required
              />
            </label>
          </div>

          <div className="advertisment__form_input">
            <label className="input-label">
              <h5>Phone Number:</h5>
              <input
                type="tel"
                name="phone"
                value={details.phone}
                onChange={handleChange}
                placeholder="Enter Phone Number"
                className="advertisment__form_input_small"
                required
              />
            </label>
          </div>

          <div className="advertisment__form_input">
            <label className="input-label">
              <h5>Application Details:</h5>
              <textarea
                name="application"
                value={details.application}
                onChange={handleChange}
                placeholder="Enter Application Details"
                className="advertisment__form_input_small"
                style={{ height: '120px', resize: 'vertical', padding: '10px' }}
                required
              />
            </label>
          </div>

          <div className="button-container">
            {loading ? (
              <Loader small={true} />
            ) : (
              <button className="advertisment__form_button" type="submit">
                <span>{isEdit ? "Update" : "Add"} Admission</span>
              </button>
            )}
          </div>
        </form>
      </div>
    </div>
  );
};

export default NewAdmission_Form;
